import React, { useEffect, useState } from "react";
import { storeApi } from "./StoreContext";
import { useDocumentTitle } from "./StorefrontLayout";
import { MapPin, Phone, Clock, ExternalLink } from "lucide-react";

export default function Stores() {
  useDocumentTitle("Find a Furmigo store near you", "Visit a Furmigo retail store for in-person grooming, boarding and shopping. Find locations and directions.");
  const [stores, setStores] = useState([]);
  useEffect(() => { storeApi.branches().then(setStores); }, []);
  const visible = stores.filter(s => !(s.name || "").toUpperCase().startsWith("TEST_"));

  return (
    <div className="max-w-5xl mx-auto px-4 sm:px-6 pt-4" data-testid="stores-page">
      <div className="text-xs uppercase tracking-[0.2em] text-amber-700 font-semibold">Locations</div>
      <h1 className="font-heading text-3xl sm:text-4xl font-black mt-1">Find a Furmigo near you</h1>
      <p className="text-stone-500 text-sm sm:text-base mt-2 max-w-2xl">Drop in for grooming, boarding or to browse our shelves. Walk-ins welcome.</p>

      <div className="mt-6 grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
        {visible.map(s => (
          <StoreCard key={s.id} store={s} />
        ))}
        {visible.length === 0 && <div className="col-span-full text-stone-500 text-sm">More stores opening soon.</div>}
      </div>
    </div>
  );
}

function StoreCard({ store }) {
  const q = encodeURIComponent(`${store.name} ${store.address || ""}`);
  const mapLink = `https://www.google.com/maps/search/?api=1&query=${q}`;
  return (
    <div className="bg-white border border-stone-200 rounded-2xl overflow-hidden hover:shadow-lg transition" data-testid={`store-card-${store.id}`}>
      <div className="bg-gradient-to-br from-amber-100 to-amber-50 h-24 grid place-items-center text-amber-700">
        <MapPin className="w-10 h-10" />
      </div>
      <div className="p-4">
        <div className="font-heading text-lg font-bold">{store.name}</div>
        {store.address && (
          <div className="text-sm text-stone-600 mt-1 flex gap-1 items-start"><MapPin className="w-3.5 h-3.5 mt-0.5 shrink-0 text-stone-400" /><span>{store.address}</span></div>
        )}
        {store.phone && (
          <a href={`tel:${store.phone}`} className="text-sm text-stone-600 mt-1 flex gap-1 items-center hover:text-amber-700"><Phone className="w-3.5 h-3.5 text-stone-400" />{store.phone}</a>
        )}
        {store.opening_hours && (
          <div className="text-sm text-stone-600 mt-1 flex gap-1 items-center"><Clock className="w-3.5 h-3.5 text-stone-400" />{store.opening_hours}</div>
        )}
        <a href={mapLink} target="_blank" rel="noreferrer" className="mt-3 inline-flex items-center gap-1.5 text-sm font-semibold text-amber-700 hover:underline" data-testid={`store-map-${store.id}`}>
          Get directions <ExternalLink className="w-3.5 h-3.5" />
        </a>
      </div>
    </div>
  );
}
